import {
  BUTTON_COLOR_MODE,
  type StyleChildProps,
} from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import ButtonStyle from 'hb-builder/components/BuilderComponents/single/Button/ButtonSettings/Style/Button';

const Button = ({
  handleBulkChange,
  item,
  parentItem,
}: Pick<StyleChildProps, 'handleBulkChange' | 'item' | 'parentItem'>) => {
  if (
    parentItem.attributes?.buttonColorMode !== BUTTON_COLOR_MODE.DIFFERENT &&
    item.attributes
  ) {
    return (
      <ButtonStyle
        defaultAttributes={item.attributes}
        item={item}
        onChange={handleBulkChange}
      />
    );
  }

  return null;
};

export default Button;
